// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"7955c4b1","247":"09ba78de","284":"fedf77ee","627":"81182af0","736":"676c6281","867":"60c6f7c9","923":"2b6be0ba","938":"5c14c375"}[chunkId] + ".chunk.js";
};